export const MULTIPLE_KEY = 'multiple' as const;

export type MultipleKey = typeof MULTIPLE_KEY;
